<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Payment Debug" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Transaction ID</label>
                                    <input class="form-control" type="text" placeholder="Enter transaction id" v-model="transaction_id">
                                </div>
                            </div>
                            <div class="col-md-4" v-if="transaction_id && !payment_verification">
                                <div style="margin-top: 30px;">
                                    <button class="btn btn-primary" @click="verifyTransaction">Verify Transaction</button>
                                </div>
                            </div>
                            <div class="col-md-4" v-else-if="transaction_id && payment_verification">
                                <div style="margin-top: 30px;">
                                    <button class="btn btn-primary" @click="fixTransaction">Fix Transaction</button>
                                </div>
                            </div>
                            <div class="col-md-4" v-if="transaction_id || payment_verification">
                                <div style="margin-top: 30px; width: 100%; display: flex; justify-content: flex-end;">
                                    <button class="btn btn-secondary" @click="clear">Clear</button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-7">
                                <h5 v-if="payment_verification">Verification Result:</h5>
                                <pre v-if="payment_verification" style="height: 500px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">{{ payment_verification }}</pre>
                            </div>
                            <div class="col-md-5">
                                <h5 v-if="payment_fix">Fix Result:</h5>
                                <pre v-if="payment_fix" style="height: 500px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">{{ payment_fix }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            transaction_id: null,
            payment_verification: null,
            payment_fix: null
        };
    },

    methods: {
        verifyTransaction() {
            this.$store.dispatch("payment/verifyPayment", {
                tran_id: this.transaction_id
            }).then(response => {
                if (response.code == 200) {
                    this.payment_verification = response
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.message,
                        icon: "error"
                    });
                }
            })
        },

        fixTransaction() {
            this.$store.dispatch("payment/fixPayment", {
                tran_id: this.transaction_id
            }).then(response => {
                if (response.code == 200) {
                    this.payment_fix = response
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.message,
                        icon: "error"
                    });
                }
            })
        },

        clear() {
            this.transaction_id = null;
            this.payment_verification = null;
            this.payment_fix = null;
        }
    }
};
</script>
